import { createAction, props } from '@ngrx/store';
import { IUpdateWithdrawalRequest, IWithdrawalsResponse } from '../models/withdrawals.model';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';

export const loadEmployeeWithdrawals = createAction('[EmployeeDetails] Load EmployeeWithdrawals', props<{ customerId: string }>());

export const loadEmployeeWithdrawalsSuccess = createAction(
  '[EmployeeDetails] Load EmployeeWithdrawals Success',
  props<{ response: IWithdrawalsResponse }>()
);

export const loadEmployeeWithdrawalsFailure = createAction(
  '[EmployeeDetails] Load EmployeeWithdrawals Failure',
  props<{ error: Error | any }>()
);

//Update if user is deceased -----------------------------
export const updateWithdrawalRequest = createAction(
  '[Withdrawal] Load Update Withdrawal request',
  props<{ customerId: string; withdrawalId: string; request: IUpdateWithdrawalRequest }>()
);

export const updateWithdrawalResponse = createAction(
  '[Withdrawal] Load Update Withdrawal Success',
  props<{ response: { success: true } }>()
);

export const updateWithdrawalFailure = createAction(
  '[Withdrawal] Load Update Withdrawal Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//Mark as Requested
export const markAsRequestedRequest = createAction(
  '[Withdrawal] Load Mark as Requested request',
  props<{ customerId: string; withdrawalId: string }>()
);

export const markAsRequestedResponse = createAction(
  '[Withdrawal] Load Mark as Requested Success',
  props<{ response: { success: true } }>()
);

export const markAsRequestedFailure = createAction(
  '[Withdrawal] Load Mark as Requested Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

// Download playback
export const loadDownloadPlaybacks = createAction('[Playbacks] Load Playbacks', props<{ name: string }>());

export const loadDownloadPlaybacksSuccess = createAction('[Playbacks] Load Playbacks Success', props<{ response: any }>());

export const loadDownloadPlaybacksFailure = createAction('[Playbacks] Load Playbacks Failure', props<{ error: Error | any }>());
